import { Box, Typography } from '@mui/material';
import { StyledButton, ButtonContainer, Container as StyledContainer } from '../pages/Questionnaire/styles';

export default function StartView({ payload, onNext }) {
  const { message } = payload;
  return (
    <StyledContainer style={{ zIndex: 500 }}>
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Typography variant="h4" align="center" style={{ direction: "rtl" }} gutterBottom>
          ברוכים הבאים
        </Typography>

        <Typography variant="body1" align="center" style={{ direction: "rtl" }} paragraph>
          {message}
        </Typography>
      </Box>

      <ButtonContainer style={{ justifyContent: 'center', marginTop: 'auto' }}>
        <StyledButton variant="contained" onClick={() => onNext()}>
          התחל
        </StyledButton>
      </ButtonContainer>
    </StyledContainer>
  );
}
